
// reference to last opened menu
var $lastOpened = false;

  
// simply close the last opened menu on document click
$(document).click(function(){
  if($lastOpened){
    $lastOpened.removeClass('open');
  }
});


// simple event delegation
$(document).on('click', '.pulldown-toggle', function(event){
  
  // jquery wrap the el
  var el = $(event.currentTarget);
  
  // prevent this from propagating up
  event.preventDefault();
  event.stopPropagation();

  // check for open state
  if(el.hasClass('open')){
    el.removeClass('open');
  }else{
    if($lastOpened){
      $lastOpened.removeClass('open');
    }
    el.addClass('open');
    $lastOpened = el;
  }
  
});

//for slider on single product page

	$ = jQuery;
$( document ).ready(function() {
  
  $h_slider_options =  {
      gallery: true,
      item: 1,
      loop:true,
      slideMargin: 0,
      thumbItem: 6,
      galleryMargin: 10,
      thumbMargin: 10,
      }; 

  $v_slider_options = {
      gallery: true,
      item: 1,
      loop:true,
      slideMargin: 0,
      thumbItem: 6,
      galleryMargin: 10,
      thumbMargin: 10,
      vertical: true
  };

  h_slider = $('#lightSlider').lightSlider($h_slider_options);
  v_slider = $('#lightSliderVertical').lightSlider($v_slider_options);

  $selector = '#lightSlider li:not(".clone") a';
  $selector += ',#lightSliderVertical li:not(".clone") a';
  $().fancybox({
    selector : $selector,
    backFocus : false, 
    buttons : [ 
      'slideShow',
      'share',
      'zoom',
      'fullScreen',
      'thumbs',
      'download',
      'close'
    ]
  });
});

$( window ).resize(function() {
		slider.destroy();
		h_slider = $('#ocassions-slider').lightSlider(h_slider_options);
});

//FOR OWL CAROUSEL

$(document).ready(function() {

$('.product-testimonial').owlCarousel({
     items:1,
  autoplay:true,
  smartSpeed:200,
  mouseDrag:true,
    loop:true,
    margin:10,
    nav:false,
  	dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
});
});


// single-product

function sixbtn(){
  document.getElementById('six-outer').style.backgroundColor ='rgba(228,228,228,.2)';
  document.getElementById('six-outer1').style.backgroundColor ='#fff';
}

function sixbtn1(){
  document.getElementById('six-outer').style.backgroundColor ='#fff';
  document.getElementById('six-outer1').style.backgroundColor ='rgba(228,228,228,.2)';
}


function onebtn(){
  document.getElementById('one-outer').style.backgroundColor ='rgba(228,228,228,.2)';
  document.getElementById('one-outer1').style.backgroundColor ='#fff';
  document.getElementById('month-btn').style.display ='none';
}

function onebtn1(){
  document.getElementById('one-outer').style.backgroundColor ='#fff';
  document.getElementById('one-outer1').style.backgroundColor ='rgba(228,228,228,.2)';
    document.getElementById('month-btn').style.display ='block';

}

//product-test slider

$(document).ready(function() {
  $('#product-test').owlCarousel({
    loop: true,
    dots:true,
    margin: 10,
    responsiveClass: true,
    autoplay:true,
    smartspeed:500,
    responsive: {
      0: {
        items: 1,
        nav: false
      },
      600: {
        items: 1,
        nav: false
      },
      1000: {
        items: 1,
        nav: false,
        loop: true,
        margin: 20
      }
    }
  })
})

$(document).ready(function(){
  	$('.header-nav.mobile-nav .header-box .nav-toggle').click(function(){
  		$('.header-nav.mobile-nav .header-box .nav-toggle').toggleClass('open-toggle');
        $('.navbar-navi').toggleClass('show-nav');
      	$('.header_area').toggleClass('full-sticky-header');
	});
});